export default __webpack_public_path__ + "static/clinic_card_desktop-54c278d6e3bd11ee57a92bc54e6608a7.png";